import { Modal, Image } from "react-bootstrap";
import heartImage from "../../../img/autoagendamientov2/corazon.svg";
import { FaTimesCircle } from "react-icons/fa";

export default function ModalSuccessV2({ open, setItems }) {
  return (
    <Modal
      show={open}
      onHide={() => setItems((prev) => ({ ...prev, showSuccess: false }))}
      size="md"
      className="modalSuccessV2"
    >
      <FaTimesCircle
        className="position-absolute"
        style={{
          right: "1%",
          top: "1%",
          fontSize: "2rem",
          zIndex: 9,
        }}
        onClick={() => setItems((prev) => ({ ...prev, showSuccess: false }))}
      />
      <Modal.Body>
        <div className="px-5 py-3">
          <div className="text-center">
            <h1 className="colorLink">Gracias</h1>
            <p className="colorLabel fw-medium">Por tu evaluación</p>
            <Image src={heartImage} height={200} width={200} />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
